<script lang="ts">
  import { Router, Route, NotFoundRoute, redirect } from "./utils/pager";
  import LoginPage from "./pages/Login/LoginPage.svelte";
  import DashboardPage from "./pages/Dashboard/DashboardPage.svelte";
  import ProfilePage from "./pages/Profile/ProfilePage.svelte";
  import NotFoundPage from "./pages/NotFound/NotFoundPage.svelte";
  import { isUserRoleADM, user } from "./app.store";
  import { initialize } from "./app.logic";
  import { get } from "svelte/store";
  import DossierListPage from "./pages/Dossier/DossierListPage.svelte";
  import ActivityListPage from "./pages/Activity/ActivityListPage.svelte";
  import TimesheetListPage from "./pages/Timesheet/TimesheetListPage.svelte";
  import TimerListPage from "./pages/Timer/TimerListPage.svelte";
  import UserListPage from "./pages/User/UserListPage.svelte";
  import SettingsPage from "./pages/Settings/SettingsPage.svelte";
  import UserDetailPage from "./pages/User/UserDetailPage.svelte";
  import CustomerListPage from "./pages/Customer/CustomerListPage.svelte";
  import CustomerDetailPage from "./pages/Customer/CustomerDetailPage.svelte";
  import DossierDetailPage from "./pages/Dossier/DossierDetailPage.svelte";
  import ActivityDetailPage from "./pages/Activity/ActivityDetailPage.svelte";

  // const data1 = { foo: "bar", custom: true };

  const loginGuard = (_ctx: any, next: any) => {
    // user.subscribe((u) => {
    // console.log("loginGuard user:", u);
    let u = get(user);
    // check if user is authenticated
    if (u === null) {
      // redirect("/login");
      initialize();
    } else {
      // go to the next callback in the chain
      next();
      //redirect("/dashboard");
    }
    // });
  };

  const adminGuard = (_ctx: any, next: any) => {
    let adm = get(isUserRoleADM);
    if (!adm) {
      redirect("/");
    } else {
      next();
    }
  };

  const defaultRouteGuard = (_ctx: any, _next: any) => {
    redirect("/dashboard");
  };

  // onMount(initialize);
</script>

<!--
  <nav>
    <a href="/">home</a>
    <a href="/about">about</a>
    <a href="/profile/joe">profile</a>
    <a href="/login">login</a>
  </nav>
-->

<Router>
  <Route path="/" middleware={[loginGuard, defaultRouteGuard]}>
    <div class="initial-loader" />
  </Route>
  <Route path="/login" component={LoginPage} />
  <!--
  <Route
    middleware={[loginGuard]}
    path="/profile/:username"
    component={ProfilePage}
  />
  -->
  <!-- <Route path="/dashboard" middleware={[loginGuard]} component={DashboardPage} data={data1} /> -->
  <Route path="/profile" middleware={[loginGuard]} component={ProfilePage} />
  <Route path="/dashboard" middleware={[loginGuard]} component={DashboardPage} />
  <Route path="/dossier" middleware={[loginGuard]} component={DossierListPage} />
  <Route path="/dossier/:oid" middleware={[loginGuard]} component={DossierDetailPage} />
  <Route path="/activity" middleware={[loginGuard]} component={ActivityListPage} />
  <Route path="/activity/:oid" middleware={[loginGuard]} component={ActivityDetailPage} />
  <Route path="/timesheet" middleware={[loginGuard]} component={TimesheetListPage} />
  <Route path="/timer" middleware={[loginGuard]} component={TimerListPage} />
  <Route path="/customer" middleware={[loginGuard]} component={CustomerListPage} />
  <Route path="/customer/:oid" middleware={[loginGuard]} component={CustomerDetailPage} />
  <Route path="/user" middleware={[loginGuard, adminGuard]} component={UserListPage} />
  <Route path="/user/:oid" middleware={[loginGuard, adminGuard]} component={UserDetailPage} />
  <Route path="/settings" middleware={[loginGuard, adminGuard]} component={SettingsPage} />

  <!--
    <Route
      path="/profile/:username"
      let:params
      middleware={[guard]}
      component={Profile}
    />
    -->
  <NotFoundRoute>
    <NotFoundPage />
  </NotFoundRoute>
</Router>

<!--<style>
  main {
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }
  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
  nav a {
    padding-right: 3rem;
  }
</style>-->
